(function(){
  var applyStoryModalProgress = function(modal){
    if (!modal) return;
    var shell = modal.querySelector('.lbx-story-v14__shell');
    if (!shell) return;
    var update = function(){
      var progress = Math.max(0, Math.min(1, shell.scrollTop / 180));
      modal.style.setProperty('--lbx-story-visual-progress', progress.toFixed(3));
    };
    update();
    shell.removeEventListener('scroll', shell.__lbxStoryVisualHandler || function(){});
    shell.__lbxStoryVisualHandler = update;
    shell.addEventListener('scroll', update, { passive: true });
  };

  var bind = function(){
    document.querySelectorAll('.lbx-story-v10__modal').forEach(applyStoryModalProgress);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  var observer = new MutationObserver(function(){ bind(); });
  observer.observe(document.documentElement, { childList:true, subtree:true });
})();
